import PaymentMethodsListTitle from './payment_methods_list_title';

export default PaymentMethodsListTitle;
